import script from "./CollectPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectPage.vue?vue&type=script&setup=true&lang=js"

import "./CollectPage.vue?vue&type=style&index=0&id=3fd65dd1&lang=css"

const __exports__ = script;

export default __exports__